import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/api";

export const CtaButton = ({ children = "Riserva il tuo posto", testid, className = "" }) => (
  <button type="button" data-testid={testid} onClick={() => scrollToId("iscrizione")} className={`btn-gold group ${className}`}>
    <span>{children}</span>
    <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
  </button>
);
